import React, {useMemo} from "react";
import AudioVisualizer from "../../AudioVisualizer/AudioVisualizer";
import Conversation from "../../Conversation/Conversation";
import Carousel from "./Carousel";
import Phrases from "./Phrases";

/**
 * Header component for the voice search modal
 * Contains company logo, conversation display, and close button
 */
const Header = ({
    baseUrl,
    onClose,
    currentText,
    currentHold,
    is_data_load,
    apiConfig,
    isHistoryVisible,
    onToggleHistory,
    assistantReply,
    isLiveConversation,
    isAwaitingAssistantReply
}) => {

    const isHold = typeof currentHold === "boolean" ? currentHold : false;

    const memoizedCarousel = useMemo(() => {
        return <Carousel items={apiConfig.carouselData} autoplay={true}/>;
    }, []);

    const memoizedPhrases = useMemo(() => {
        return <Phrases items={apiConfig.phrases}/>;
    }, []);
    return (
        <div
            className="bg-[#F9F9F9] z-10 px-3 md:px-5 lg:px-6 xl:px-10 pt-6 pb-16 md:pt-8 md:pb-8 lg:pt-6 lg:pb-8 rounded-tl-2xl rounded-tr-2xl relative">
            <div className="flex lg:pr-[0.75rem] flex-wrap items-center justify-start sm:justify-between gap-2 md:gap-4 lg:gap-6 relative">
                {apiConfig.profileImageUrl ? (
                    <img
                        src={apiConfig.profileImageUrl}
                        alt="Company Logo"
                        className="hidden sm:block w-12 md:w-16 lg:w-20 xl:w-32 2xl:w-auto max-h-[2rem]"
                    />
                ) : (
                    <div></div>
                )}
                <div className="flex flex-grow max-w-[92%] sm:max-w-full px-2 md:px-3 lg:px-4 py-0 h-11 md:h-10 2xl:h-14 bg-white rounded items-stretch justify-center  overflow-hidden">

                    {isHold && window.innerWidth <= 1024 ? (
                        <div className="flex h-full items-center">
                            <AudioVisualizer
                                width={window.innerWidth >= 1024 ? "120" : window.innerWidth >= 640 ? "100" : "40"}
                                height={window.innerWidth >= 1024 ? "25" : window.innerWidth >= 640 ? "20" : "15"}
                                color="#FFFFFF"
                                is_opning={true}
                                barCount={window.innerWidth >= 1024 ? "120" : window.innerWidth >= 640 ? "100" : "40"}
                            />
                        </div>
                    ) : (
                        <div className="hidden sm:flex h-full items-center">
                            <AudioVisualizer
                                width={window.innerWidth >= 1024 ? "120" : window.innerWidth >= 640 ? "100" : "80"}
                                height={window.innerWidth >= 1024 ? "25" : window.innerWidth >= 640 ? "20" : "15"}
                                color="#FFFFFF"
                                is_opning={true}
                                barCount={window.innerWidth >= 1024 ? "120" : window.innerWidth >= 640 ? "100" : "80"}
                            />
                        </div>
                    )}
                    <Conversation
                        conversation={currentText}
                        isHold={isHold}
                        assistantReply={assistantReply}
                        isLiveConversation={isLiveConversation}
                        isAwaitingAssistantReply={isAwaitingAssistantReply}
                    />
                </div>
                <>
                    <style>
                        {`
                    @keyframes spinBorder {
                        from { transform: rotate(0deg); }
                        to { transform: rotate(360deg); }
                                }
                    `}
                    </style>

                    <button
                        type="button"
                        onClick={onToggleHistory}
                        style={{
                            position: "relative",
                            marginLeft: "1rem",
                            padding: "6px",
                            borderRadius: "9999px",
                            border: "none",
                            transition: "background 0.3s",
                            background: isHistoryVisible ? "#8A82C6" : "#FFFFFF",
                            color: isHistoryVisible ? "#fff" : "#4B5563",
                        }}
                        aria-label="Toggle conversation history"
                        title="Conversation history"
                    >
                        {(isHold || isAwaitingAssistantReply) && (
                            <span
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    borderRadius: "9999px",
                                    padding: "10px",
                                    background: "conic-gradient(#9C95DC, #0B7189, #9C95DC)",
                                    animation: "spinBorder 1.8s linear infinite",

                                    WebkitMask:
                                        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                                    WebkitMaskComposite: "xor",
                                    maskComposite: "exclude",

                                    pointerEvents: "none",
                                }}
                            />
                        )}

                        <span style={{ position: "relative", zIndex: 1 }}>
                            <img
                                src={`${baseUrl}/images/chatrobotnew.svg`}
                                alt="Chat Robot"
                                className='w-[40px] md:w-10 2xl:w-14'
                            />
                        </span>
                    </button>
                </>
                {localStorage.getItem("recodemo") === "1" && (
                    <a
                        href={process.env.REACT_APP_DEMO_URL}
                        className="hidden sm:block bg-[#0B7189] hover:bg-[#0b7189b3] rounded-[50px]
                         text-[#F9F9F9] text-[clamp(12px,1.11vw,16px)] w-48 py-4 text-center inline-block"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Go to Our Main Site
                    </a>
                )}
            </div>
            {(window.innerWidth >= 640 || !is_data_load) && memoizedCarousel}
            {!is_data_load && memoizedPhrases}
            <button
                onClick={onClose}
                className="border-none absolute top-2 md:top-3 lg:top-4 right-2 md:right-3 lg:right-4
                    w-4 md:w-5 lg:w-6 h-4 md:h-5 lg:h-6
                    flex items-center justify-center bg-[#D9D9D9] hover:bg-gray-300 rounded-full z-20"
                aria-label="Close"
            >
                <img src={`${baseUrl}/images/close_button.svg`} alt="Close"
                     className="w-2 lg:w-3 h-2  lg:h-3"/>
            </button>
        </div>
    );
};

export default Header;